{#if breadcrumbs.length}

<nav class="breadcrumbs">

    <ul class="list list--inline">

        {#each breadcrumbs as breadcrumb, index (breadcrumb.url)}

        <li>

            {#if index < breadcrumbs.length - 1}

            <Link to={breadcrumb.url} class="danger">{breadcrumb.title}</Link>

            {:else}

            {breadcrumb.title}

            {/if}

        </li>

        {/each}

    </ul>

</nav>

{/if}

<style>

    .breadcrumbs {

    }

    .breadcrumbs ul {
        margin: 0;
        padding: 1rem 2rem;
    }

    .breadcrumbs ul li {
        /* margin: 0 0.5rem; */
        margin: 0;
    }

    .breadcrumbs ul li::after {
        content: '/';
        margin-left: 0.5rem;
        margin-right: 0.5rem;
    }

    .breadcrumbs ul li:last-child:after {
        content: '';
    }
    
</style>

<script>
    // components
    import Link from 'components/Link.html'

    export default {
        components: {
            Link
        },
        oncreate() {
            const createBreadcrumbs = (pathname) => {
                let url = '/'
                let breadcrumbs = []
                
                if (pathname.length > 1) {
                    breadcrumbs.push({
                        title: 'home',
                        url
                    })
                }
                
                pathname.split('/').filter(Boolean).forEach(segment => {
                    url = `${url}/${segment}`

                    breadcrumbs.push({
                        title: segment,
                        url
                    })
                })

                return breadcrumbs 
            }

            const component = this
            const history = window.customHistory

            history.listen(location => {
                component.set({
                    breadcrumbs: createBreadcrumbs(location.pathname)
                })
            })

            component.set({
                breadcrumbs: createBreadcrumbs(history.location.pathname)
            })
        },
        data() {
            return {
                breadcrumbs: []
            }
        }
    }
</script>